const ValidationCheckRules = ['missing', 'invalid'];
type ValidationCheckRule = typeof ValidationCheckRules[number];

export interface IFormErrorInfo {
  concerns: string;
  validationLevel: ValidationCheckRule[];
}

export interface IFieldValidationRule {
  fieldName: string;
  checkRules: ValidationCheckRule[];
  pattern?: RegExp;
}

const getNestedField = (model: any, fieldName: string) => {
  const fieldNames = fieldName.split('.');
  let field = { ...model };
  fieldNames.forEach(name => {
    if (field !== undefined && field !== null) {
      field = field[name];
    } else {
      field = undefined;
    }
  });
  return field;
};

const checkMissingField = (model: any, fieldName: string): boolean => {
  const nestedField = getNestedField(model, fieldName);
  return (
    !!model &&
    ((nestedField &&
      typeof nestedField === 'object' &&
      Object.keys(nestedField).length > 0) ||
      nestedField === 0 ||
      (typeof nestedField !== 'object' && !!nestedField))
  );
};

const checkInvalidField = (
  model: any,
  fieldName: string,
  pattern: RegExp
): boolean => {
  const nestedField = getNestedField(model, fieldName);

  return (
    !!model &&
    typeof nestedField !== 'object' &&
    (!nestedField || pattern.test(nestedField))
  );
};

const testCheckRule = (
  model: object,
  fieldName: string,
  checkRule: ValidationCheckRule,
  pattern?: RegExp
): boolean => {
  if (checkRule === 'missing') {
    return checkMissingField(model, fieldName);
  }

  if (checkRule === 'invalid' && pattern) {
    return checkInvalidField(model, fieldName, pattern);
  }
  return !!model;
};

const getFieldError = (
  model: object,
  rule: IFieldValidationRule
): IFormErrorInfo => {
  const { checkRules, fieldName, pattern } = rule;

  if (rule && checkRules && checkRules.length) {
    const invalidRules = rule.checkRules.filter(
      checkRule => !testCheckRule(model, fieldName, checkRule, pattern)
    );

    if (invalidRules.length > 0) {
      return { concerns: rule.fieldName, validationLevel: invalidRules };
    }
  }
  return null;
};

export const getInvalidFields = (
  model: object,
  rules: IFieldValidationRule[]
): IFormErrorInfo[] => {
  const invalidFields: IFormErrorInfo[] = [];
  rules.forEach(rule => {
    const invalidField = getFieldError(model, rule);
    if (invalidField) {
      invalidFields.push(invalidField);
    }
  });

  return invalidFields;
};

export const getPatternValidationErrorMsg = (
  invalidFields: IFormErrorInfo[],
  fieldName: string
) => {
  return invalidFields &&
    invalidFields.some(
      iField =>
        iField.concerns === fieldName &&
        iField.validationLevel.includes('invalid')
    )
    ? 'Validation error. Check field value'
    : '';
};
